module.exports = __webpack_public_path__ + "media/images/lp_v6_border3-f6e75ff24af90a9d448fceb7005fb0b0.webp";